import { EGGSHELL_CREW, GREEN_CREW, Product, SOCKS } from '../products';

const blackHatRecos: Product[] = [
    GREEN_CREW,
    EGGSHELL_CREW,
    SOCKS,   
];

export default blackHatRecos;